<template>
    <v-row class="px-2">
        <v-col xs="12" sm="6" v-for="(p,i) in posts" :key="i">
            <v-card dark max-width="400" class="my-2 grey darken-2">
                <v-card-subtitle class="pb-0 font-weight-bold font-italic">{{p.title}}</v-card-subtitle>
                <v-card-text class="py-0 text-caption">{{postDateFormat(p.created_at)}}</v-card-text>
                <v-card-text  class="py-2">{{p.content}}</v-card-text>
                <v-card-actions class="pa-0">
                    <v-list-item class="grow">
                        <v-list-item-avatar color="grey darken-3">
                            <v-img class="elevation-6" :src="avatar(p.avatar)"></v-img>
                        </v-list-item-avatar>
                        
                        <v-list-item-content>
                            <v-list-item-title>{{p.userName}}</v-list-item-title>
                        </v-list-item-content>

                        <v-row align="center" justify="end">
                            <v-icon class="mr-1">mdi-heart</v-icon>
                            <span class="subheading mr-2"> {{p.likes}} </span>
                        </v-row>
                    </v-list-item>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { postDateFormat } from '../../utils/date';

export default {
    props: ["posts"],
    mounted() {},
    methods: {
        postDateFormat,
        avatar(src) {
            return src? src : "https://api.minimalavatars.com/avatar/avatar/png"
        }
    }
}
</script>

<style>

</style>